module.exports = __webpack_public_path__ + "static/buildings_block-bb5a88ba6cdc8eea40fa64bb8ca5cdf4.png";